export const SOURCE_CALLS = "calls"
export const SOURCE_CALL_CENTER = "call_center_api"
export const SOURCE_WEBSITE_FORM = "website_form"
export const SOURCE_ONLINE_CHAT = "online_chat"
export const SOURCE_VOICEMAIL = "voicemail"
export const ALL_SOURCES = "all"
export const MIN_SEARCH_LENGTH = 2

export const LEAD_SOURCE_OPTIONS = [
  { value: ALL_SOURCES, label: "All sources" },
  { value: SOURCE_CALLS, label: "Calls" },
  { value: SOURCE_CALL_CENTER, label: "Call Center API" },
  { value: SOURCE_WEBSITE_FORM, label: "Website Form" },
  { value: SOURCE_ONLINE_CHAT, label: "Online Chat" },
  { value: SOURCE_VOICEMAIL, label: "Voicemail" },
] as const
